/* eslint-disable no-undef */
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Table } from "antd";
import SearchBox from "../../../../components/SearchBox";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import GoalTrackingModal from "../../../../components/modelpopup/GoalTrackingModal";
import DeleteModal from "../../../../components/modelpopup/DeleteModal";
import ProtectedButton from "../../../../Routes/Approuter/ProtectedButton";
import {
  formatDateInTimezone,
  formatDateTimeInTimezone,
  getCurrentDate,
} from "./../../../../utils/formatDateInTimezone";
import DatePicker from "react-datepicker";
import "../../../../assets/css/goalTracking.css";
import { companyID } from "../../../../auth";
import getFirstGoalPerCycle from "../../../../utils/dataFormating";
import api from "../../../../api/axios";

const GoalTracking = () => {
  const navigate = useNavigate();
  const [goalData, setGoalData] = useState([]);
  const [goalDataError, setGoalDataError] = useState(null);
  const [paginationValue, setPaginationValue] = useState(5);
  const date = new Date();
  const current_year = date.getFullYear();
  const location = useLocation();

  const [selectedYear, setSelectedYear] = useState(current_year);
  const employee_id = localStorage.getItem("employeeID");

  const getAllMainGoalData = async () => {
    try {
      if (employee_id && selectedYear) {
        const response = await api.get(
          `performance/get-main-goal/${employee_id}?year=${selectedYear}`
        );
        if (response?.data?.result?.length > 0) {
          const data = getFirstGoalPerCycle(response?.data?.result);
          setGoalData(data);
        } else {
          setGoalData([]);
          setGoalDataError("No Data Found");
        }
      }
    } catch (err) {
      console.error("No Data Found", err);
      setGoalDataError("No Data Found");
    }
  };
  useEffect(() => {
    getAllMainGoalData();
  }, [selectedYear]);

  const columns = [
    {
      title: "Goal Cycle",
      dataIndex: "cycle_name",
    },
    {
      title: "Goal",
      dataIndex: "main_goal",
      // sorter: (a, b) => a.main_goal.length - b.main_goal.length,
    },
    // {
    //   title: "Weightage",
    //   dataIndex: "weightage",
    //   // sorter: (a, b) => a.weightage.length - b.weightage.length,
    //   render: (text) => <div className="">{text}%</div>,
    // },
    // {
    //   title: "Start Date",
    //   dataIndex: "start_date",
    //   // sorter: (a, b) => a.start_date.length - b.start_date.length,
    //   render: (text, record) => <>{formatDateInTimezone(record.start_date)}</>,
    // },
    // {
    //   title: "End Date",
    //   dataIndex: "end_date",
    //   // sorter: (a, b) => a.end_date.length - b.end_date.length,
    //   render: (text, record) => <>{formatDateInTimezone(record.end_date)}</>,
    // },
    {
      title: "Created Date",
      dataIndex: "created_at",
      render: (text, record) => <>{formatDateInTimezone(record.created_at)}</>,
      // sorter: (a, b) => formatDateInTimezone(a.created_at).length - formatDateInTimezone(b.created_at).length,
    },

    {
      title: "Submission Status",
      dataIndex: "submission_status_name",
      render: (text, record) => (
        <div
          className=" "
          style={{
            color:
              record?.submission_status == 1 || record?.submission_status == 4
                ? "red"
                : record?.submission_status == 2
                ? "#f2be3a"
                : "#3A7D44",
          }}
        >
          {text}
        </div>
      ),
    },
    {
      title: "Edit Deadline",
      dataIndex: "edit_deadline",
      render: (text, record) =>
        record?.final_performance_reviewed == 0 ? (
          <div className="text-danger">
            {record?.edit_deadline
              ? formatDateInTimezone(record?.edit_deadline)
              : "-"}
          </div>
        ) : (
          "-"
        ),
      // sorter: (a, b) => formatDateInTimezone(a.created_at).length - formatDateInTimezone(b.created_at).length,
    },
    {
      title: "Performance Approval",
      dataIndex: "final_performance_reviewed",
      render: (text, record) => (
        <div
          className=" "
          style={{ color: text == 0 ? "#f2be3a" : text == 1 ? "#3A7D44" : "" }}
        >
          {text == 1 ? "Approved" : text == 0 ? "Pending" : "-"}
        </div>
      ),
    },
    {
      title: "Status",
      dataIndex: "goal_status_name",
      render: (text) => (
        <div className="badge " style={{ backgroundColor: "#3A7D44" }}>
          {text}
        </div>
      ),
      // sorter: (a, b) => a.status.length - b.status.length,
    },
    {
      title: "Action",
      render: (record) => (
        <div style={{ fontSize: "14px" }}>
          <i
            class="fa-solid fa-eye"
            style={{ color: "#12ade0" }}
            onClick={() => handleNavigation(record?.cycle_id, false)}
          ></i>{" "}
          {record?.submission_status == 1 &&
            formatDateTimeInTimezone(record?.edit_deadline) >=
              getCurrentDate() && (
              <i
                class="fa-solid fa-pencil ml-4"
                style={{ color: "#12ade0" }}
                onClick={() => handleNavigation(record?.cycle_id, true)}
              ></i>
            )}
        </div>
      ),
    },
  ];

  const handleNavigation = (cycle_id, edited, creatingNewGoal) => {
    const navigationState = creatingNewGoal
      ? createGoal?.goal_creation_status == 1
        ? false
        : true
      : goalData?.length > 0
      ? true
      : false;

    const queryParams =
      goalData?.length > 0
        ? `employee_id=${employee_id}&year=${selectedYear}`
        : `employee_id=${employee_id}&year=${selectedYear}`;

    navigate(`../manage-goal${queryParams ? `?${queryParams}` : ""}`, {
      state: {
        hasGoals: navigationState,
        reviewer: false,
        back: "/goal-list",
        goal_review_deadline: null,
        isReviewed: null,
        cycle_id: cycle_id,
        edited: edited,
        creatingNewGoal: creatingNewGoal,
      },
    });
  };

  const [selfGoalReviewCycle, setSelfGoalReviewCycle] = useState(null);
  const [goalReviewSubmission, setGoalReviewSubmission] = useState(null);
  const [goalEditSubmission, setGoalEditSubmission] = useState(null);
  const [performanceReview, setPerformanceReview] = useState(null);
  const [createGoal, setCreateGoal] = useState({});
  const [visibleCreateGoal, setVisibleCreateGoal] = useState([]);

  const fetchConfiguration = async (selectedYear) => {
    const company_id = companyID();
    const current_date = getCurrentDate();
    const employee_id = localStorage.getItem("employeeID");
    const response = await api.get(
      `performance/goal-config?company_id=${company_id}&current_date=${current_date}&current_year=${selectedYear}&employee_id=${employee_id}`
    );
    if (response?.data?.result?.length > 0) {
      setCreateGoal(response?.data?.result[0]);
      const data = goalData?.filter(
        (item) => item?.cycle_id != response?.data?.result[0]?.cycle_id
      );
      setVisibleCreateGoal(data);
    } else {
      setCreateGoal({});
    }
  };
  useEffect(() => {
    fetchConfiguration(selectedYear);
  }, [selectedYear]);

  const CustomInput = ({ value, onClick }) => (
    <input
      type="text"
      value={value}
      onClick={onClick}
      readOnly // Prevents manual typing
      className="form-control custome_date_change"
      style={{
        backgroundColor: "white", // Change to your preferred color
        cursor: "pointer",
        border: "1px solid #ccc",
      }}
    />
  );

  return (
    <>
      <div className="page-wrapper">
        {/* Page Content */}
        <div className="content container-fluid">
          {/* Page Header */}
          <Breadcrumbs
            maintitle={`Goal For ${selectedYear}`}
            title="Dashboard"
            subtitle="Goal"
            // modal="#add_goal"
            // name="Add New"
          />
          <div className="d-flex align-items-center justify-content-end">
            <div>
              <DatePicker
                className="custom-datepicker-in-navigation "
                selected={new Date(selectedYear, 0, 1)}
                onChange={(date) => {
                  const year = date.getFullYear();
                  setSelectedYear(year);
                }}
                dateFormat="yyyy"
                showYearPicker
                showMonthDropdown={false}
                showDayDropdown={false}
                minDate={new Date(2010, 0, 1)}
                maxDate={new Date(current_year, 11, 31)}
                id="year-picker"
                customInput={<CustomInput />}
              />
            </div>
            {selectedYear == current_year &&
              createGoal?.goal_creation_status == 1 && (
                <ProtectedButton page="goal-list" action="create">
                  <button
                    onClick={() =>
                      handleNavigation(createGoal?.id, false, true)
                    }
                    className=" btn btn-link"
                  >
                    <i class="fa-solid fa-plus"></i> <span>Create Goal</span>
                  </button>
                </ProtectedButton>
              )}
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="table-responsive">
                <div className="d-flex justify-content-between align-item-center"></div>
                <div className="col-md-12 mb-3 text-danger">
                  {/* {(goalData[0]?.edit_deadline && goalData[0]?.submission_status == 1 ) && <span>Deadline for Goal Modification : {formatDateInTimezone(goalData[0]?.edit_deadline)} </span>} */}
                </div>
                {goalData.length > 0 && goalData[0].submission_status != 2 ? (
                  <Table
                    className="table-striped"
                    columns={columns}
                    dataSource={goalData}
                    pagination={{ pageSize: paginationValue }}
                    scroll={{ x: true }}
                  />
                ) : (
                  <p className="text-center fs-22 mt-5">No data</p>
                )}
              </div>
            </div>
          </div>
        </div>
        {/* /Page Content */}
      </div>
      <GoalTrackingModal />
      <DeleteModal Name="Delete Goal Tracking List" />
    </>
  );
};

export default GoalTracking;
